
import axios from 'axios'
import {cookieStorage} from './sessionStore'
import VueRouter from '../../router'
import Vue from "vue";



let toast = ({html}) => {
    // console.log(html)
}

let onUserChanged = (user) => {};

class Auth {

    constructor(Vue, options){


        let defaultOption = {

            expirationTime: 3600,

            // Route Redirection
            authRedirect:       {path: '/login'},
            forbiddenRedirect:  {path: '/403'},
            notFoundRedirect:   {path: '/404'},


            // Api
            registerData:       {url: '/api/register',      method: 'POST', redirect: null},
            loginData:          {url: '/api/login',         method: 'POST', redirect: null, rememberMe: false},
            logoutData:         {url: '/api/logout',        method: 'POST', redirect: null, makeRequest: false},
            fetchData:          {url: '/api/info',          method: 'GET'},
            refreshTokenData:   {url: '/api/token/refresh', method: 'POST'},
            downloadData:       {method: 'GET', responseType: 'blob'},

            onStartLoading: () => {},
            onFinishLoading: () => {},
        }

        for (let a in options) {
            if(defaultOption[a]) {
                options[a] = Object.assign({}, defaultOption[a], options[a])
            }
        }

        this._options = Object.assign({}, defaultOption, options)

        if(this._options.onUserChanged)
            onUserChanged = this._options.onUserChanged

        this.http = axios
        // Enable sending cookies with all requests (for HttpOnly JWT cookie)
        this.http.defaults.withCredentials = true
        this.router = VueRouter


        this.onStartLoading = this._options.onStartLoading
        this.onFinishLoading = this._options.onFinishLoading

        // Store the redirect URL after login
        this.redirectAfterLogin = null

        // Refresh token state
        this._isRefreshing = false
        this._refreshSubscribers = []

        this.watch = new Vue({
            data() {
                return {
                    data: {

                    },
                    user: {},
                    dateExpiration: null,
                    redirect: null,
                    authenticated: null // null = unknown, true = authenticated, false = not authenticated
                }
            },
            methods: {
                isExpired() {
                    return this.dateExpiration < new Date()
                }
            },
            watch: {
                user: (val) => {
                    onUserChanged(val)
                }
            }
        });


        this.router.beforeEach((to, from, next) => {

            if (to.meta.auth === false && this.check() === true) {
                // User is authenticated but trying to access auth=false page (like login)
                from = to
                to = {path: '/'}
                next(to)
            } else if (to.meta.auth === true && this.check() === false) {
                // User is definitely not authenticated, redirect to login
                // Note: if check() is null (unknown), we allow navigation and let /api/me determine auth
                this.redirectAfterLogin = to.fullPath
                from = to
                to = this._options.authRedirect
                next(to)
            } else if (to.meta.allowed_roles){
                let roles = to.meta.allowed_roles
                roles.push('super_admin')
                roles.push('admin')

                let isGranted = false
                for(let r in roles) {
                    if (this.isGranted(roles[r])) {
                        isGranted = true
                        break;
                    }
                }
                if(isGranted) {
                    next()
                } else {
                    next('/403')
                }

            } else {
                next()
            }

            this.watch.redirect = {to, from}

        })

        // Auth state will be set by setAuthenticated() called from Layout after /api/me
        // Initial state is null (unknown) until first API call determines it
    }

    // Called by Layout after successful /api/me call
    setAuthenticated(authenticated, userData = null) {
        this.watch.authenticated = authenticated
        if (userData) {
            this.user(userData)
        } else if (!authenticated) {
            this.watch.user = {}
        }
    }

    check() {
        return this.watch.authenticated;
    }



    redirect() {
        return this.watch.redirect
    }

    clearSession(){
        this.watch.user = {}
        this.watch.authenticated = false
    }

    login(data) {

        return new Promise((resolve, reject) => {
            let _data = Object.assign({}, this._options.loginData, data)
            _data._noToken = true
            _data.headers = {
                'Content-Type': 'application/json'
            }

            this.fetch(_data)
                .then(response => {
                    // Backend sets HttpOnly cookie
                    // User info will be fetched by Layout via /api/me
                    this.watch.authenticated = true

                    // Check if there's a redirect saved
                    if(this.redirectAfterLogin) {
                        const redirect = this.redirectAfterLogin
                        // Clear the stored redirect
                        this.redirectAfterLogin = null
                        // Redirect to the original page
                        this.router.replace(redirect)
                    } else if(_data.redirect) {
                        // Fallback to the redirect specified in data
                        this.router.replace(_data.redirect)
                    } else {
                        // Default redirect to dashboard
                        this.router.replace({name: 'dashboard'})
                    }
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }


    register(data) {
        return new Promise((resolve, reject) => {
            let _data = Object.assign({}, this._options.registerData, data)
            _data._noToken = true
            this.fetch(_data)
                .then(response => {
                    if(_data.redirect) {
                        this.router.push(_data.redirect)
                    }
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })

    }

    logout(data) {
        return new Promise((resolve, reject) => {

            let _data = Object.assign({}, this._options.logoutData, data)

            let _success = () => {
                this.clearSession()
                if(_data.redirect && _data.redirect !== this.router.currentRoute.path ) {
                    this.router.push(_data.redirect)
                }
            }

            if(_data.makeRequest) {
                this.fetch(_data)
                    .then(response => {
                        _success()
                        resolve(response)
                    })
                    .catch(err => {
                        reject(err)
                    })
            } else {
                _success()
                resolve()
            }
        })
    }


    downloadAsBase64(data) {
        return new Promise((resolve, reject) => {
            this.fetch({...data, responseType: 'arraybuffer'}).then(response => {
                let filename = null
                let contentDisposition = response.headers["content-disposition"];
                if (contentDisposition) {
                    let match = contentDisposition.match(/filename\*=(.+?)'(.*?)'(.+?)(?:;|$)/i);
                    if (match) {
                        const encoding = match[1].toUpperCase(); // Exemple : 'UTF-8'
                        const urlEncodedFilename = match[3];

                        // Pour le moment, on gère uniquement UTF-8 de manière standard
                        if (encoding === 'UTF-8') {
                            filename = decodeURIComponent(urlEncodedFilename);
                        } else {
                            // Gérer d'autres encodages si nécessaire (nécessite des bibliothèques supplémentaires en JS)
                            filename = urlEncodedFilename;
                        }
                    }
                }
                resolve({arrayBuffer: response.data, type: response.headers['content-type'], filename})
            }).catch(async err => {
                let blob = new Blob([err.response.data], { type: err.response.headers['content-type'] } );
                err.response.data = JSON.parse(await blob.text())
                reject(err)
            })
        })
    }
    download(data) {

        return new Promise((resolve, reject) => {
            let _data = Object.assign({}, this._options.downloadData, data)

            let filename = null
            if(_data.filename) {
                filename = _data.filename
            }


            this.fetch(_data)
                .then(response => {
                let blob = new Blob([response.data]);

                if(!filename) {
                    let contentDisposition = response.headers["content-disposition"];
                    if (contentDisposition) {
                        let match = contentDisposition.match(/filename\*=(.+?)'(.*?)'(.+?)(?:;|$)/i);
                        if (match) {
                            // Extraire l'encodage et le nom de fichier encodé
                            const encoding = match[1].toUpperCase(); // Exemple : 'UTF-8'
                            const urlEncodedFilename = match[3];

                            // Pour le moment, on gère uniquement UTF-8 de manière standard
                            if (encoding === 'UTF-8') {
                                filename = decodeURIComponent(urlEncodedFilename);
                            } else {
                                // Gérer d'autres encodages si nécessaire (nécessite des bibliothèques supplémentaires en JS)
                                filename = urlEncodedFilename;
                            }
                        } else {
                            // Sinon, chercher la forme classique de filename
                            match = contentDisposition.match(/filename=(.+?)(?:;|$)/i);
                            if (match) {
                                filename = match[1].replace(/^["']|["']$/g, '');
                            }
                        }
                    } else {
                        let fileParts = _data.url.split('/');
                        filename = fileParts[fileParts.length-1];

                        fileParts = _data.url.split('.');
                        if(fileParts.length < 2) {
                            filename += ".txt";
                        }
                    }
                }

                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    let blobURL = window.URL.createObjectURL(blob);
                    let tempLink = document.createElement('a');
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', filename);

                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
                resolve(response)
            }).catch(async err => {
                let blob = err.response.data;
                if(blob) {
                    const text = await blob.text()
                    try {
                        err.response.data = JSON.parse(text)
                    } catch (e) {
                        err.response.data = text
                    }
                }
                reject(err)
            })
        })
    }

    fetch(data) {

        return new Promise((resolve, reject) => {
            let _data = Object.assign({}, this._options.fetchData, data)

            if(_data.noLoading !== true) {
                this.onStartLoading()
            }


            let _config = {
                url: _data.url,
                method: _data.method?.toLowerCase() ?? 'get',
                data: _data.data ? _data.data : {},
                signal: _data.signal ? _data.signal : null,
                withCredentials: true, // Always send cookies
            }

            let contentType = 'application/json;charset=UTF-8'
            if(_data.data !== 'get' && _data.data instanceof FormData) {
                contentType = 'multipart/form-data'
            }


            _config.headers = {
                'Content-type': contentType,
            }

            if(cookieStorage.get('local')) {
                _config.headers['Accept-Language'] = cookieStorage.get('local')
            }

            if(_data.headers) {
                _config.headers = {
                    ..._config.headers,
                    ..._data.headers
                }
            }


            if(_data.responseType) {
                _config.responseType = _data.responseType
            }

            // No more Authorization header - auth is via HttpOnly cookie

            let _error = err => {
                if(_data.noLoading !== true) {
                    this.onFinishLoading()
                }
                if (err && err.response && err.response.status === 401) {
                    this.clearSession()
                    if(!_data._noToken) {
                        // Save the current URL to redirect after login
                        this.redirectAfterLogin = this.router.currentRoute.fullPath
                        this.router.push(this._options.authRedirect)
                    }
                }
                reject(err)
            }

            if(_config.data && _config.method.toLowerCase() === 'get') {
                _config.params = _config.data
                delete _config.data
            }


            if(!_config.data) {
                _config.data = {}
            }

            this.http(_config).then(
                response => {
                    if(_data.noLoading !== true) {
                        this.onFinishLoading()
                    }
                    resolve(response)
                }
            ).catch(
                err => {
                    if (!this.http.isCancel(err)) {
                        let res = err.response;
                        if (res) {

                            if (res.status === 403) {
                                _error(err)
                            } else if (res.status === 404) {
                                _error(err)
                            } else if (res.status === 401 && !_data._noToken && !_data._isRetry) {
                                // Try to refresh the token
                                this.refreshToken()
                                    .then(() => {
                                        // Retry the original request
                                        this.fetch({ ..._data, _isRetry: true })
                                            .then(resolve)
                                            .catch(reject)
                                    })
                                    .catch(() => {
                                        // Refresh failed, redirect to login
                                        _error(err)
                                    })
                            } else {
                                _error(err)
                            }

                        } else {
                            _error(err)
                        }
                    }
                }
            )
        })
    }

    // Subscribe to token refresh - callers wait until refresh completes
    _subscribeToRefresh(callback) {
        this._refreshSubscribers.push(callback)
    }

    // Notify all subscribers after refresh attempt
    _onRefreshComplete(success) {
        this._refreshSubscribers.forEach(callback => callback(success))
        this._refreshSubscribers = []
    }

    refreshToken() {
        // If already refreshing, return a promise that resolves when refresh completes
        if (this._isRefreshing) {
            return new Promise((resolve, reject) => {
                this._subscribeToRefresh(success => {
                    if (success) resolve()
                    else reject({ response: { status: 401 } })
                })
            })
        }

        this._isRefreshing = true

        return new Promise((resolve, reject) => {
            const refreshConfig = {
                url: this._options.refreshTokenData.url,
                method: this._options.refreshTokenData.method?.toLowerCase() ?? 'post',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            this.http(refreshConfig)
                .then(response => {
                    this._isRefreshing = false
                    this._onRefreshComplete(true)
                    resolve(response)
                })
                .catch(err => {
                    this._isRefreshing = false
                    this._onRefreshComplete(false)
                    reject(err)
                })
        })
    }

    token() {
        // With HttpOnly cookies, we can't access the token
        // Return a dummy object for compatibility
        if (this.watch.authenticated) {
            return { accessToken: '[HttpOnly]', refreshToken: '[HttpOnly]' }
        }
        return false
    }

    isGranted(role) {
        return this.user().roles ? this.user().roles.includes(role) : false
    }

    user(data) {
        if (data) {
            this.watch.user = data;
        }

        return this.watch.user || {};
    }

    isExpired() {
        return this.watch.isExpired() || false;
    }

    serialize(data) {
        let formData = new FormData()
        for(let a in data) {
            if(data[a])
                formData.append(a, data[a])
        }
        return formData
    }


}

export default Auth
